import { useState } from "react";
import { Mail, Send, MapPin, Clock } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/contact", form);
      toast.success(data.message || "Message envoyé !");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Erreur d'envoi");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-[1100px] mx-auto px-4 sm:px-8 lg:px-12 py-12 lg:py-16" data-testid="contact-page">
      <p className="eyebrow mb-2">Une question ?</p>
      <h1 className="font-display text-4xl sm:text-5xl font-black uppercase text-stone-100 mb-4">Contactez-nous</h1>
      <p className="text-stone-400 mb-12 max-w-xl">
        Notre équipe vous répond sous 24h ouvrées. Commande, produit, livraison — nous sommes là pour vous.
      </p>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
        <div className="space-y-6">
          {[
            { icon: Mail, t: "Email", s: "mfaby.digit@gmail.com" },
            { icon: Clock, t: "Horaires", s: "Lun – Ven · 9h à 18h" },
            { icon: MapPin, t: "Support", s: "Assistance en ligne France" },
          ].map((c) => (
            <div key={c.t} className="flex items-start gap-4">
              <div className="h-11 w-11 rounded-xl bg-amber-500/10 border border-amber-500/30 flex items-center justify-center shrink-0">
                <c.icon className="h-5 w-5 text-amber-500" />
              </div>
              <div>
                <p className="font-bold text-stone-100">{c.t}</p>
                <p className="text-sm text-stone-400">{c.s}</p>
              </div>
            </div>
          ))}
        </div>

        <form onSubmit={submit} className="lg:col-span-2 gothic-card rounded-2xl p-8 space-y-5">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <div>
              <label className="block text-sm text-stone-400 mb-2">Nom</label>
              <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name"
                className="w-full bg-[#0b0810] border border-amber-900/40 rounded-lg px-4 py-3 text-stone-100 focus:outline-none focus:border-amber-600" />
            </div>
            <div>
              <label className="block text-sm text-stone-400 mb-2">Email</label>
              <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email"
                className="w-full bg-[#0b0810] border border-amber-900/40 rounded-lg px-4 py-3 text-stone-100 focus:outline-none focus:border-amber-600" />
            </div>
          </div>
          <div>
            <label className="block text-sm text-stone-400 mb-2">Message</label>
            <textarea required rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message"
              className="w-full bg-[#0b0810] border border-amber-900/40 rounded-lg px-4 py-3 text-stone-100 focus:outline-none focus:border-amber-600 resize-none" />
          </div>
          <button type="submit" disabled={loading} data-testid="contact-submit" className="btn-ember rounded-xl px-8 py-3.5 inline-flex items-center gap-2 disabled:opacity-60">
            <Send className="h-4 w-4" /> {loading ? "Envoi…" : "Envoyer le message"}
          </button>
        </form>
      </div>
    </div>
  );
}
